import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { formReportServices } from "../../../../APIServices/formReportServices";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";

const InsertFooterDetails = ({ type }) => {
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [loader, setLoader] = useState("");
  const { studyId } = useParams();

  const findReportStudyMetadataData = async () => {
    setLoader(true);
    let data = await formReportServices.findReportStudyMetadataData(
      type, studyId
    );
    setTitle(data?.data?.footerData?.title1);
    setSubTitle(data?.data?.footerData?.title2);
    setLoader(false);
  };

  const addUpdateReportStudyMetadata = async (e) => {
    let datas = {
      studyId
    };
    datas.type = type;
    datas.footerData = {
      title1: title,
      title2: subTitle,
    };
    let data = await formReportServices.addUpdateReportStudyMetadata(datas);
    if (data?.statusCode === 200) {
      findReportStudyMetadataData();
    }
  };

  useEffect(() => {
    findReportStudyMetadataData();
  }, []);

  return (
    <>
      {loader ? (
        <PageLoader />
      ) : (
        <div className="py-2 px-3">
          <Form.Label className="mb-1 fw-bold">Add Footer Title</Form.Label>
          <div className="hstack gap-2 mb-2">
            <Form.Control
              type="text"
              placeholder={`Enter Footer Title 1`}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <Form.Control
              type="text"
              placeholder={`Enter Footer Title 2`}
              value={subTitle}
              onChange={(e) => setSubTitle(e.target.value)}
            />
          </div>
          <div className="text-end">
            <button
              className="updateProfile"
              onClick={addUpdateReportStudyMetadata}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default InsertFooterDetails;
